// Configuration file for controlling which titles are selectable for each print medium type
// Use '*' to show all titles for that medium type
// Use an array of specific titles to show only those titles
// Use an empty array to show no titles

export const titleFilterConfig = {
    'Display': [
        '*'
    ],
    'Video': [
        '*'
    ],
    'Online': [
        '*'
    ],
    'Nieuwsbrief': [
        '*'
    ],
    'Radio': [
        '*'
    ],
    'Podcast': [
        '*'
    ],
    'Social': [
        '*'
    ],
  // Dagblad medium type
  'Dagblad': [
    '*'
    // 'De Telegraaf',
    // 'De Telegraaf, editie Amsterdam',
    // 'Noordhollands Dagblad',
    // 'NHD - Helderse Courant',
    // 'NHD - Schager Courant',
    // 'NHD - Dagblad voor West-Friesland',
    // 'NHD - Alkmaarsche Courant',
    // 'NHD - Dagblad Kennemerland',
    // 'NHD - Dagblad Zaanstreek',
    // 'NHD - Dagblad Waterland',
    // 'Haarlems Dagblad',
    // 'IJmuider Courant',
    // 'Haarlems Dagblad / IJmuider Courant',
    // 'Leidsch Dagblad',
    // 'De Gooi- en Eemlander',
    // 'Regionale Dagbladen Noord',
    // 'Dagblad van het Noorden',
    // 'Dagblad van het Noorden Groningen',
    // 'Dagblad van het Noorden Drenthe',
    // 'Leeuwarder Courant',
    // 'Friesch Dagblad',
    // 'De Limburger (Hele Oplage)',
    // 'De Limburger Maastricht-Heuvelland',
    // 'De Limburger Parkstad Limburg',
    // 'De Limburger Midden Limburg',
    // 'De Limburger Noord Limburg',
    // 'De Limburger Westelijke Mijnstreek'
  ],

  // Magazine medium type
  'Magazine': [
    // Add specific magazine titles or use '*' for all
    '*'
  ],

  // Nieuws- en weekbladen (combines Nieuwsblad and Weekblad)
  'Nieuws- en weekbladen': [
    // Add specific news/week titles or use '*' for all
    '*'
  ],

  // Print (totaal) medium type
  'Print (totaal)': [
    // Add specific print total titles or use '*' for all
    // '*'
  ],

  // Special medium type
  'Special': [
    // Add specific special titles or use '*' for all
    '*'
  ],

  // Weekkrant medium type
  'Weekkrant': [
    // Add specific weekkrant titles or use '*' for all
    '*'
  ],

  // Mediahuis Connect medium type
  'Mediahuis Connect': [
    '*'
    // Add specific Mediahuis Connect titles or use '*' for all
    // 'Mediahuis Connect (Dagbladen)',
    // 'Mediahuis Connect Regionaal (Dagbladen)',
    // 'De Telegraaf + Mediahuis Regionale Dagbladen West', // TODO : fix this

  ],
};

// Helper function to check if a title should be shown for a given medium type
export const shouldShowTitle = (mediumType, title) => {
  const config = titleFilterConfig[mediumType];
  
  if (!config) {
    return true; // If no config exists, show all titles
  }

  // If config contains '*', show all titles
  if (config.includes('*')) {
    return true;
  }

  // If config is empty array, show no titles
  if (config.length === 0) {
    return false;
  }

  // Show only titles that are explicitly listed in the config
  return config.includes(title);
};

// Helper function to get all available titles for a medium type
export const getAvailableTitles = (mediumType) => {
  const config = titleFilterConfig[mediumType];
  
  if (!config) {
    return []; // If no config exists, return empty array
  }

  // If config contains '*', return all (this will be handled in the main logic)
  if (config.includes('*')) {
    return '*';
  }

  // Return the specific titles from config
  return config;
}; 